import { Typography } from '@components/ui';
import { CheckmarkFilled, CloseFilled, TooltipFilled } from '@icon';
import React from 'react';
import { useTheme } from 'styled-components';
import { NotificationSC } from './notification.styled';

export type TProps = {
  type?: 'ERROR' | 'SUCCESS' | 'default';
  title: string | React.ReactNode;
  copy: string | React.ReactNode;
  onClick?: () => void;
};

const Notification: React.FC<TProps> = ({ type, title, copy, ...rest }) => {
  const theme = useTheme();

  return (
    <NotificationSC type={type} {...rest}>
      <div className="notification-header">
        {!type || type === 'default' ? (
          <TooltipFilled
            width={16}
            height={16}
            color={theme.color.solid.info}
            style={{ marginRight: 8 }}
          />
        ) : type === 'ERROR' ? (
          <CloseFilled
            width={16}
            height={16}
            color={theme.color.solid.error}
            style={{ marginRight: 8 }}
          />
        ) : (
          <CheckmarkFilled
            width={16}
            height={16}
            color={theme.color.solid.success}
            style={{ marginRight: 8 }}
          />
        )}
        <Typography display="h6">{title}</Typography>
      </div>
      <p>{copy}</p>
    </NotificationSC>
  );
};

export default Notification;
